if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      descriptionContainer = null;
      descriptionToggle = null;
      productDescription = null;

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
        this.productInfoContainer = this.querySelector(".product_main__form");
        this.productMainInfo = this.querySelector(".product_main_info");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
        this.initProductDescriptionDisplay();
        this.watchingProductInfoWrapper();
        this.initGlobloCustom();
      }

      updateProductInfoHeight() {
        if (!this.productInfoContainer || !this.productMainInfo) return;

        const containerHeight = this.productInfoContainer.clientHeight;
        this.productMainInfo.style.minHeight = `${containerHeight + 100}px`;
        const galleryContainer = this.querySelector(".product_main__gallery");
        const galleryContainerHeight = galleryContainer.clientHeight || 0;

        const desktopContentContainer = this.querySelector(".desktop_description_container .desktop_description_content");
        if(desktopContentContainer) {
          desktopContentContainer.style.minHeight = `${containerHeight - galleryContainerHeight}px`;
        }

        const desktopContainer = this.querySelector("#product__description__desktop__container #product__description__container");
        if(desktopContainer) {
          const heightContainer = containerHeight - galleryContainerHeight - 154;
          const minHeightContainer = 500;
          const maxHeight = Math.max(heightContainer, minHeightContainer);
          desktopContainer.style.maxHeight = `${maxHeight}px`;
        }
        this.initDesktopDescriptionCollapse();
      }

      initDesktopDescriptionCollapse() {
        if(window.innerWidth < 992) { 
          return;
        }
        
        const desktopContainer = this.querySelector("#product__description__desktop__container #product__description__container");
        const toggleEl = this.querySelector("#product__description__desktop__container [data-toggle-desc]");
        const arrowUp = toggleEl.querySelector("span.up");
        const arrowDown = toggleEl.querySelector("span.down");

        if(!desktopContainer) return;
        if(!toggleEl) return;

        const maxHeight = parseInt(desktopContainer.style.maxHeight) || 0;
        if(desktopContainer.scrollHeight < maxHeight) {
          toggleEl.style.display = "none";
          desktopContainer.classList.remove("product__description__collapsed");
        } else {
          toggleEl.style.display = "block";
          desktopContainer.classList.add("product__description__collapsed");
        if (toggleEl.dataset.initialized === 'true') return;

          this.desktopToggleHandler = () => {
            const containerHeight = this.productInfoContainer.clientHeight;
            const galleryContainer = this.querySelector(".product_main__gallery");
            const galleryContainerHeight = galleryContainer.clientHeight || 0;
            const heightContainer = containerHeight - galleryContainerHeight - 154;
            const minHeightContainer = 500;
            const collapseHeight = Math.max(heightContainer, minHeightContainer);

            if (desktopContainer.classList.contains("product__description__collapsed")) {
              desktopContainer.classList.remove("product__description__collapsed");
              desktopContainer.style.maxHeight = desktopContainer.scrollHeight + "px";
              if (arrowDown) arrowDown.style.display = "none";
              if (arrowUp) arrowUp.style.display = "inline-block";
            } else {
              desktopContainer.classList.add("product__description__collapsed");
              desktopContainer.style.maxHeight = collapseHeight + "px";
              if (arrowDown) arrowDown.style.display = "inline-block";
              if (arrowUp) arrowUp.style.display = "none";
            }
          };
          
          toggleEl.addEventListener("click", this.desktopToggleHandler);
          
          // Mark as initialized
          toggleEl.dataset.initialized = 'true';
        }
        
      }

      watchingProductInfoWrapper() {
        if (!this.productInfoContainer || !this.productMainInfo) return;

        const resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === this.productInfoContainer) {
              this.updateProductInfoHeight();
            }
          }
        });

        resizeObserver.observe(this.productInfoContainer);

        this.productInfoResizeObserver = resizeObserver;

        this.updateProductInfoHeight();
      }

      initGlobloCustomGuideButton() {
        const globo = this.querySelector(".gpo-container");
        if (!globo) return;
        const elements = globo.querySelectorAll(".gpo-element");
        if (!elements || elements.length === 0) return;
        const productInfo = document.querySelector("product-info");
        if (!productInfo) return;

        const quickLink1 = productInfo.dataset["quickLink-1"]?.split("|") || [];
        const quickLink2 = productInfo.dataset["quickLink-2"]?.split("|") || [];
        const quickLink3 = productInfo.dataset["quickLink-3"]?.split("|") || [];

        // ['Size Guide', 'ruler', '/blogs/news/how-to-measure-your-belt-size', 'LUG / BUCKLE WIDTH']

        const quickLinks = [
          { data: quickLink1, iconSelector: ".quick_link_icon_1" },
          { data: quickLink2, iconSelector: ".quick_link_icon_2" },
          { data: quickLink3, iconSelector: ".quick_link_icon_3" },
        ];
        quickLinks.forEach(({ data, iconSelector }) => {
          if (!data || data.length === 0) return;
          elements.forEach((element) => {
            const sectionName = element.querySelector(
              "label.gpo-label .label-content"
            );
            if (sectionName && sectionName.innerText === data[3]) {
              const title = element.querySelector("label.gpo-label");
              if (!title) return;
              const quickLinkIcon =
                document.querySelector(iconSelector)?.innerHTML || "";
              title.style.justifyContent = "space-between";
              title.style.alignItems = "center";
              title.style.gap = "10px";
              title.style.width = "100%";

              const guideButton = document.createElement("a");
              guideButton.classList.add("gpo-guide-button");
              guideButton.href = data[2];
              guideButton.target = "_blank";
              guideButton.innerHTML = quickLinkIcon + data[0];
              title.appendChild(guideButton);
            }
          });
        });
      }

      initGlobloCustomColorSelect() {
        const productGalleryNew = this.querySelector("new-media-gallery");
        const globo = this.querySelector(".gpo-container");
        if (!globo) return;
        const elements = globo.querySelectorAll(".gpo-element");
        if (!elements || elements.length === 0) return;

        // ===================== material select
        const materialSelect = Array.from(elements).filter(
          (element) => {
            const labelContent = element.querySelector(".label-content")?.innerText?.toLocaleLowerCase?.() || "";
            const keyWord = "PRIMARY LEATHER".toLocaleLowerCase();
            const keyWordVn = "DA CHỦ ĐẠO".toLocaleLowerCase();
            return labelContent.indexOf(keyWord) !== -1 || labelContent.indexOf(keyWordVn) !== -1;
          }
        );

        if (materialSelect.length > 0) {
          const firstMaterialSelect = materialSelect[0];
          const materialSelectItems = firstMaterialSelect.querySelectorAll(
            '.dropdown-item.gpo-ov-item input[type="radio"]'
          );

          if (materialSelectItems.length > 0) {
            materialSelectItems.forEach((material) => {
              material.addEventListener("change", (event) => {
                const target = event?.target;
                if (productGalleryNew && target && typeof target.getAttribute === 'function') {
                  const isCheckedAttr =
                    target.getAttribute("previous-value");
                  const isChecked = isCheckedAttr === "checked";
                  const currentMaterialGroupFilter =
                    productGalleryNew.getCurrentMaterialGroupFilter();
                  if (isChecked) {
                    if (currentMaterialGroupFilter === target.value) return;
                    productGalleryNew.setActiveMaterialGroup(target.value);
                  }
                  selectFirstColorOptionAvailable();
                }
              });
            });
          }
        }

        const getCurrentMaterialGroupFilter = () => {
          if (!productGalleryNew) return null;
          if(materialSelect.length === 0) return null;
          const firstMaterialSelect = materialSelect[0];
          const materialSelectItems = firstMaterialSelect.querySelectorAll(
            '.dropdown-item.gpo-ov-item input[type="radio"]'
          );
          if (materialSelectItems.length === 0) return null;
          const activeMaterial = Array.from(materialSelectItems).find(
            (material) => material.checked
          );
          return activeMaterial ? activeMaterial.value : null;
        }

        // ===================== color select
        const colorSelect = Array.from(elements).filter(
          (element) => {
            const labelContent = element.querySelector(".label-content")?.innerText?.toLocaleLowerCase?.() || "";
            const keyWord = "COLOR".toLocaleLowerCase();
            const keyWordVn = "MÀU".toLocaleLowerCase();
            return labelContent.indexOf(keyWord) !== -1 || labelContent.indexOf(keyWordVn) !== -1;
          }
        );

        colorSelect.forEach((element) => {
          const colorSelectItems = element.querySelectorAll(
            '.image-swatches.gpo-ov-item input[type="radio"]'
          );
          if (colorSelectItems.length > 0) {
            colorSelectItems.forEach((color) => {
              color.addEventListener("change", (event) => {
                const target = event?.target;
                if (productGalleryNew && target && typeof target.getAttribute === 'function') {
                  const isCheckedAttr =
                    target.getAttribute("previous-value");
                  const isChecked = isCheckedAttr === "checked";
                  const currentColorFilter =
                    productGalleryNew.getCurrentColorFilter();
                  if (isChecked) {
                    if (currentColorFilter === target.value) return;
                    const currentMaterialGroupFilter = getCurrentMaterialGroupFilter();
                    if(currentMaterialGroupFilter) {
                      productGalleryNew.setActiveMaterialGroup(currentMaterialGroupFilter);
                    }
                    productGalleryNew.filterByColor(target.value);
                  } else {
                    productGalleryNew.restoreOriginalItems();
                    productGalleryNew.setCurrentColorFilter(null);
                    setTimeout(() => {
                      productGalleryNew.reinitializeSliders();
                    }, 100);
                  }
                }
              });
            });
          }
        });

        // trigger select first color option if there's only one to apply the filter on page load
        const selectFirstColorOptionAvailable = () => {
          if(colorSelect.length) {
            let firstColorSelect = colorSelect[0];
            if(firstColorSelect.hasAttribute("data-has-clo")){
              const cloColorSelect = colorSelect.find((element) => element.hasAttribute("data-has-clo") && element.getAttribute("data-clo-display") === "hide");
              if(cloColorSelect) {
                firstColorSelect = cloColorSelect;
              }
            }
            const colorSelectItems = firstColorSelect.querySelectorAll(
              '.image-swatches.gpo-ov-item input[type="radio"]'
            );
            if (colorSelectItems.length) {
              const firstColor = colorSelectItems[0];
              if(firstColor) {
                const nextLabelSibling = firstColor.nextElementSibling;
                if (nextLabelSibling && nextLabelSibling.tagName.toLocaleLowerCase() === "label") {
                  nextLabelSibling.click();
                }
              }
            }
          }
        }

        selectFirstColorOptionAvailable();
      }

      initGlobloCustom() {
        document.addEventListener("gpoRenderCompleted", () => {
          this.updateProductInfoHeight();
          this.initGlobloCustomGuideButton();
          this.initGlobloCustomColorSelect();
        });
      }

      initProductDescriptionDisplay() {
        const descriptionContainerDesktop = document.getElementById("product__description__desktop__container");
        const descriptionContainerMobile = document.getElementById("product__description__mobile__container");
        if(!descriptionContainerMobile) return;
        if(!descriptionContainerDesktop) return;
        this.productDescription = descriptionContainerMobile.innerHTML;

        const handleDisplay = () => {
          const isMobile = window.innerWidth < 993;
          const isOnMobile = (descriptionContainerMobile.innerHTML || '').trim().length > 0;
          const isOnDesktop = (descriptionContainerDesktop.innerHTML || '').trim().length > 0;
          if(!descriptionContainerMobile) return;
          if (isMobile) {
            if (isOnDesktop) {
              descriptionContainerMobile.innerHTML = this.productDescription;
              descriptionContainerDesktop.innerHTML = '';
            }
          } else {
            if (isOnMobile) {
              descriptionContainerDesktop.innerHTML = this.productDescription;
              descriptionContainerMobile.innerHTML = '';
            }
          }
        }

        handleDisplay();
        this.addProductDescriptionToggle();
        window.addEventListener("resize", handleDisplay);
      }

      addProductDescriptionToggle() {
        const mobileContainer = document.getElementById("product__description__mobile__container");

        const attach = (container) => {
          if (!container) return;

          const handler = (e) => {
            const toggleEl = e.target.closest("[data-toggle-desc]");
            if (!toggleEl || !container.contains(toggleEl)) return;

            const descContainer = container.querySelector("[data-description]");
            if (!descContainer) return;

            const arrowUp = toggleEl.querySelector("span.up");
            const arrowDown = toggleEl.querySelector("span.down");
            const collapseHeight = window.innerWidth > 768 ? 500 : 200;

            if (descContainer.classList.contains("product__description__collapsed")) {
              descContainer.classList.remove("product__description__collapsed");
              descContainer.style.maxHeight = descContainer.scrollHeight + "px";
              if (arrowDown) arrowDown.style.display = "none";
              if (arrowUp) arrowUp.style.display = "inline-block";
            } else {
              descContainer.classList.add("product__description__collapsed");
              descContainer.style.maxHeight = collapseHeight + "px";
              if (arrowDown) arrowDown.style.display = "inline-block";
              if (arrowUp) arrowUp.style.display = "none";
            }
          };

          container.addEventListener("click", handler);

          const toggleEl = container.querySelector("[data-toggle-desc]");
          const descContainer = container.querySelector("[data-description]");
          if (toggleEl && descContainer) {
            if (descContainer.scrollHeight <= descContainer.clientHeight + 5) {
              toggleEl.style.display = "none";
            } else {
              toggleEl.style.display = "";
            }
          }
        };
        attach(mobileContainer);
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
        this.productInfoResizeObserver?.disconnect();
        
        // Clean up desktop toggle handler
        if (this.desktopToggleHandler) {
          const toggleEl = this.querySelector("#product__description__desktop__container [data-toggle-desc]");
          if (toggleEl) {
            toggleEl.removeEventListener("click", this.desktopToggleHandler);
          }
          this.desktopToggleHandler = null;
        }
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );
        this.querySelector(`new-media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        const spinner = this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        );
        spinner?.classList.remove("hidden");
        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            const spinnerEl = this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            );
            spinnerEl?.classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        if (!this.quantityForm || !quantityFormUpdated) return;
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

const getProductDescription = () => {
  const desktopDescription = document.getElementById("product__description__desktop__container");
  const mobileDescription = document.getElementById("product__description__mobile__container");

  if (desktopDescription && (desktopDescription.innerHTML || '').trim().length > 0) {
    return desktopDescription;
  }
  if (mobileDescription) return mobileDescription;
  return null;
}

const tripHtml = (html) => {
  if(!html) return "";
  return html.replace(/<[^>]*>?/g, "").trim();
}

if (!customElements.get("product-faq")) {
  customElements.define(
    "product-faq",
    class ProductFaq extends HTMLElement {
      constructor() {
        super();
        this.faqContainer = getProductDescription()
        this.faqListContainer = this.querySelector(".common-question-list");
        this.faqList = [];
        this.faqItemTemplate = this.querySelector(
          "#common-question-item-template"
        );
        this.titleDB = "FAQ".toLocaleLowerCase();
        this.questionToggleHandlers = new Map();
      }

      connectedCallback() {
        this.initFaqShowMoreToggle();
        this.initFaqListToggle();
      }

      initFaqList() {
        if (!this.faqContainer) {
          this.classList.add("hidden");
          return;
        }
        const tableOfContents =
          Array.from(this.faqContainer.querySelectorAll("table")) || [];
        if (tableOfContents.length) {
          let isFound = false;
          tableOfContents.forEach((item) => {
            const allRows = Array.from(item.querySelectorAll("tr")) || [];
            const firstRow = allRows[0];
            const firstRowCells = firstRow
              ? firstRow.querySelectorAll("td")
              : [];
            const firstRowCell =
              firstRowCells.length > 0 ? tripHtml(firstRowCells[0]?.innerHTML) : "";
            if (firstRowCell.toLocaleLowerCase().indexOf(this.titleDB) !== -1) {
              this.getFaqData(item);
              isFound = true;
            }
          });
          if (!isFound) {
            this.classList.add("hidden");
          }
        } else {
          this.classList.add("hidden");
        }
      }

      getFaqData(item) {
        const allRows = Array.from(item.querySelectorAll("tr")) || [];
        const data = allRows.reduce((acc, row, index) => {
          if (index === 0) return acc;
          const rowCells = Array.from(row.querySelectorAll("td")) || [];
          const rowCell = rowCells.length > 0 ? rowCells[0]?.innerHTML : "";
          const rowCell2 = rowCells.length > 0 ? rowCells[1]?.innerHTML : "";
          acc.push({
            question: rowCell,
            answer: rowCell2,
          });
          return acc;
        }, []);
        if (data.length > 0) {
          this.faqList = data;
          this.renderFaqList();
        } else {
          this.classList.add("hidden");
        }
      }

      renderFaqList() {
        if (!this.faqItemTemplate || !this.faqListContainer) {
          this.classList.add("hidden");
          return;
        }
        this.faqList.forEach((item) => {
          const faqItem = this.faqItemTemplate.content.cloneNode(true);
          const q = faqItem.querySelector(".question-text");
          const a = faqItem.querySelector(".question-description");
          if (q) q.innerHTML = item.question || "";
          if (a) a.innerHTML = item.answer || "";
          this.faqListContainer.appendChild(faqItem);
        });
    
      }

      initFaqShowMoreToggle() {
        const btn = this.querySelector(".faq-show-more-btn");
        const extraWrapper = this.querySelector(".faq-extra-items");
        if (!btn || !extraWrapper) return;

        btn.addEventListener("click", () => {
          const isExpanded = btn.getAttribute("aria-expanded") === "true";
          if (isExpanded) {
            // Snap from "none" to current pixel height so CSS transition has a start point
            extraWrapper.style.maxHeight = extraWrapper.scrollHeight + "px";
            // Force reflow so the browser registers the pixel value before animating
            extraWrapper.getBoundingClientRect();
            extraWrapper.style.maxHeight = "0";
            btn.setAttribute("aria-expanded", "false");
            btn.querySelector("span.down").style.display = "inline-block";
            btn.querySelector("span.up").style.display = "none";
          } else {
            extraWrapper.style.maxHeight = extraWrapper.scrollHeight + "px";
            btn.setAttribute("aria-expanded", "true");
            btn.querySelector("span.down").style.display = "none";
            btn.querySelector("span.up").style.display = "inline-block";
            // Once open, remove the cap so inner questions can expand freely
            extraWrapper.addEventListener(
              "transitionend",
              () => {
                if (btn.getAttribute("aria-expanded") === "true") {
                  extraWrapper.style.maxHeight = "none";
                }
              },
              { once: true }
            );
          }
        });
      }

      initFaqListToggle() {
        if (!this.faqListContainer) return;
        const questionToggles = this.faqListContainer.querySelectorAll(
          ".common-question-toggle"
        );
        questionToggles.forEach((toggle) => {
          const handler = function () {
            const content = this.nextElementSibling;
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            // Close all other questions
            questionToggles.forEach((otherToggle) => {
              if (otherToggle !== this) {
                otherToggle.setAttribute("aria-expanded", "false");
                otherToggle.parentElement.classList.remove("active");
                otherToggle.nextElementSibling.style.maxHeight = "0";
              }
            });

            // Toggle current question
            if (isExpanded) {
              this.setAttribute("aria-expanded", "false");
              this.parentElement.classList.remove("active");
              content.style.maxHeight = "0";
            } else {
              this.setAttribute("aria-expanded", "true");
              this.parentElement.classList.add("active");
              content.style.maxHeight = content.scrollHeight + "px";
            }
          };

          // Store the handler reference for cleanup
          this.questionToggleHandlers.set(toggle, handler);
          toggle.addEventListener("click", handler);
        });
      }
      disconnectedCallback() {
        this.questionToggleHandlers.forEach((handler, toggle) => {
          toggle.removeEventListener("click", handler);
        });
        this.questionToggleHandlers.clear();
      }
    }
  );
}

if (!customElements.get("product-user-feedback")) {
  customElements.define(
    "product-user-feedback",
    class ProductUserFeedback extends HTMLElement {
      constructor() {
        super();
        this.userFeedbackContainer = getProductDescription();
        this.userFeedbackListContainer = this.querySelector(
          ".user-feedback-swiper .swiper-wrapper"
        );
        this.userFeedbackList = [];
        this.userFeedbackItemTemplate = this.querySelector(
          "#user-feedback-item-template"
        );
        this.titleDB = "Customer Experience".toLocaleLowerCase();
        this.sliderContainer = this.querySelector(".user-feedback-swiper");
        this.slider = null;
      }

      connectedCallback() {
        this.initUserFeedbackList();
      }
      initUserFeedbackList() {
        if (!this.userFeedbackContainer) {
          this.classList.add("hidden");
          return;
        }
        const tableOfContents =
          Array.from(this.userFeedbackContainer.querySelectorAll("table")) ||
          [];
        if (tableOfContents.length) {
          let isFound = false;
          tableOfContents.forEach((item) => {
            const allRows = Array.from(item.querySelectorAll("tr")) || [];
            const firstRow = allRows[0];
            const firstRowCells = firstRow
              ? firstRow.querySelectorAll("td")
              : [];
            const firstRowCell =
              firstRowCells.length > 0 ? tripHtml(firstRowCells[0]?.innerHTML) : "";
            if (firstRowCell.toLocaleLowerCase().indexOf(this.titleDB) !== -1) {
              this.getUserFeedbackData(item);
              isFound = true;
            }
          });
          if (!isFound) {
            this.classList.add("hidden");
          }
        } else {
          this.classList.add("hidden");
        }
      }

      getUserFeedbackData(item) {
        const allRows = Array.from(item.querySelectorAll("tr")) || [];
        const data = allRows.reduce((acc, row, index) => {
          if (index === 0) return acc;
          const rowCells = Array.from(row.querySelectorAll("td")) || [];
          const rowCell = rowCells.length > 0 ? rowCells[0]?.innerHTML : "";
          const rowCell3 = rowCells.length > 0 ? rowCells[1]?.innerHTML : "";
          const rowCell4 = rowCells.length > 0 ? rowCells[2]?.innerHTML : "";
          const rowCell5 = rowCells.length > 0 ? rowCells[3]?.innerHTML : "";

          acc.push({
            name: rowCell,
            quote: rowCell3,
            productImage: rowCell4,
            avatarImage: rowCell5,
          });
          return acc;
        }, []);
        if (data.length > 0) {
          this.userFeedbackList = data;
          this.renderUserFeedbackList();
        } else {
          this.classList.add("hidden");
        }
      }

      renderUserFeedbackList() {
        if (!this.userFeedbackItemTemplate || !this.userFeedbackListContainer) {
          this.classList.add("hidden");
          return;
        }
        this.userFeedbackList.forEach((item) => {
          const userFeedbackItem = this.userFeedbackItemTemplate.content.cloneNode(true);
          const name = item.name || "";
          const trimHtml = name.replace(/<[^>]*>?/g, "").trim();
          const shortName = trimHtml.slice(0, 2).toUpperCase();
          const quoteEl = userFeedbackItem.querySelector(".feedback-quote");
          const nameEl = userFeedbackItem.querySelector(".user-name");
          const avatarEl = userFeedbackItem.querySelector(".avatar-placeholder");
          const feedbackImage = userFeedbackItem.querySelector(".feedback-image");
          if (quoteEl) quoteEl.innerHTML = item.quote || "";
          if (nameEl) nameEl.innerHTML = name;
          if (avatarEl) avatarEl.innerHTML = item.avatarImage ? item.avatarImage : `<img src="https://placehold.co/600x400?text=${shortName}" alt="${shortName + trimHtml}"/>`;
          if (feedbackImage) feedbackImage.innerHTML = item.productImage || "";
          this.userFeedbackListContainer.appendChild(userFeedbackItem);
        });
        this.initUserFeedbackListSlider();
      }

      initUserFeedbackListSlider() {
        const initializeSlider = () => {
          if (typeof window.initSlider !== "function") return;
          this.slider = window.initSlider(
            this.sliderContainer,
            {
              spaceBetween: 10,
              initialSlide: 0,
              slidesPerView: 2,
              autoplay: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              breakpoints: {
                992: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                678: {
                  slidesPerView: 2,
                },
              },
            },
            this.sliderContainer.id,
          );
        }

        // Check if initSlider is available, if not wait for it
        if (typeof window.initSlider === "function") {
          initializeSlider();
        } else {
          // Wait for initSlider to be available
          const checkInitSlider = setInterval(() => {
            if (typeof window.initSlider === "function") {
              clearInterval(checkInitSlider);
              initializeSlider();
            }
          }, 100);

          // Fallback timeout after 10 seconds
          setTimeout(() => {
            clearInterval(checkInitSlider);
            if (typeof window.initSlider !== "function") {
              console.warn("initSlider failed to load within 10 seconds");
            }
          }, 20000);
        }
      }
      disconnectedCallback() {
        if (this.slider) {
          window.destroySwiperSlider(this.sliderContainer);
        }
        this.slider = null;
      }
    }
  );
}

if (!customElements.get("product-value")) {
  customElements.define(
    "product-value",
    class ProductValue extends HTMLElement {
      constructor() {
        super();
        this.valueContainer = getProductDescription();
        this.valueListContainer = this.querySelector("#product-value-grid");
        this.valueList = [];
        this.valueItemTemplate = this.querySelector("#product-value-item-template");
        this.titleDB = "Product Value".toLocaleLowerCase();
        this.sectionTitle = this.querySelector(".product-value-title");
        this.sectionSubtitle = this.querySelector(".product-value-subtitle");
      }

      connectedCallback() {
        this.initValueList();
      }

      initValueList() {
        if (!this.valueContainer) {
          this.classList.add("hidden");
          return;
        }
        const tableOfContents =
          Array.from(this.valueContainer.querySelectorAll("table")) || [];
        if (tableOfContents.length) {
          let isFound = false;
          tableOfContents.forEach((item) => {
            const allRows = Array.from(item.querySelectorAll("tr")) || [];
            const firstRow = allRows[0];
            const firstRowCells = firstRow
              ? firstRow.querySelectorAll("td")
              : [];
            const firstRowCell =
              firstRowCells.length > 0 ? tripHtml(firstRowCells[0]?.innerHTML) : "";
            if (firstRowCell.toLocaleLowerCase().indexOf(this.titleDB) !== -1) {
              this.getValueData(item);
              isFound = true;
            }
          });
          if (!isFound) {
            this.classList.add("hidden");
          }
        } else {
          this.classList.add("hidden");
        }
      }

      getValueData(item) {
        const allRows = Array.from(item.querySelectorAll("tr")) || [];
        const data = allRows.reduce((acc, row, index) => {
          if (index === 0 || index === 1 || index === 2) {
            const rowCells = Array.from(row.querySelectorAll("td")) || [];
            const content = rowCells[0]?.innerHTML || "";
            if (index === 1) {
              if(content && this.sectionTitle) {
                this.sectionTitle.innerHTML = content || "";
                this.sectionTitle.classList.remove("hidden");
              }
            }
            if (index === 2) {
              if(content && this.sectionSubtitle) {
                this.sectionSubtitle.innerHTML = content || "";
                this.sectionSubtitle.classList.remove("hidden");
              }
            }
            return acc;
          };
          const rowCells = Array.from(row.querySelectorAll("td")) || [];
          const rowCell = rowCells.length > 0 ? rowCells[0]?.innerHTML : "";
          const rowCell2 = rowCells.length > 0 ? rowCells[1]?.innerHTML : "";
          const rowCell3= rowCells.length > 0 ? rowCells[2]?.innerHTML : "";
          acc.push({
            name: rowCell,
            description: rowCell2,
            icon: rowCell3,
          });
          return acc;
        }, []);
        if (data.length > 0) {
          this.valueList = data;
          this.renderValueList();
        } else {
          this.classList.add("hidden");
        }
      }

      renderValueList() {
        if (!this.valueItemTemplate || !this.valueListContainer) {
          this.classList.add("hidden");
          return;
        }
        this.valueList.forEach((item) => {
          const valueItem = this.valueItemTemplate.content.cloneNode(true);
          const nameEl = valueItem.querySelector(".product-value-name");
          const descEl = valueItem.querySelector(".product-value-description");
          const iconEl = valueItem.querySelector(".product-value-icon");
          if (nameEl) {
            nameEl.innerHTML = item.name || "";
            nameEl.classList.remove("hidden");
          }
          if (descEl) {
            descEl.innerHTML = item.description || "";
            descEl.classList.remove("hidden");
          }
          if (iconEl) {
            iconEl.innerHTML = item.icon || "";
            iconEl.classList.remove("hidden");
          }
          if (iconEl) {
            iconEl.innerHTML = item.icon || "";
            iconEl.classList.remove("hidden");
          }
          this.valueListContainer.appendChild(valueItem);
        });
      }
    }
  );
}

if (!customElements.get("product-image-text")) {
  customElements.define(
    "product-image-text",
    class ProductImageText extends HTMLElement {
      constructor() {
        super();
        this.productDetailContainer = getProductDescription();
        const dataId = this?.dataset?.id || "";
        this.imageTextContainer = this.querySelector("#product-image-text-container-" + dataId);
        this.imageTextList = [];
        this.imageTextItemTemplate = this.querySelector("#product-image-text-template-" + dataId);
        this.titleDB = "Image With Text".toLocaleLowerCase();
        this.indexItem = 0
      }

      connectedCallback() {
        this.initTextShowMore();
      }

      initBlockData() {
        // Guard required DOM/template elements
        if (!this.productDetailContainer || !this.imageTextContainer || !this.imageTextItemTemplate) {
          this.classList.add("hidden");
          return;
        }
        const listItems = document.querySelectorAll("product-image-text");
        this.indexItem = Array.from(listItems).findIndex((item) => item === this);
        this.initImageTextList();
      }

      initImageTextList() {
        if (!this.productDetailContainer) {
          this.classList.add("hidden");
          return;
        }
        const tableOfContents =
          Array.from(this.productDetailContainer.querySelectorAll("table")) || [];
        if (tableOfContents.length) {
          let isFound = false;
          tableOfContents.forEach((item) => {
            const allRows = Array.from(item.querySelectorAll("tr")) || [];
            const firstRow = allRows[0];
            const firstRowCells = firstRow
              ? firstRow.querySelectorAll("td")
              : [];
            const firstRowCell =
              firstRowCells.length > 0 ? tripHtml(firstRowCells[0]?.innerHTML) : "";
            if (firstRowCell.toLocaleLowerCase().indexOf(this.titleDB) !== -1) {
              this.getImageTextData(item);
              isFound = true;
            }
          });
          if (!isFound) {
            this.classList.add("hidden");
          }
        } else {
          this.classList.add("hidden");
        }
      }

      getImageTextData(item) {
        const allRows = Array.from(item.querySelectorAll("tr")) || [];
        const data = allRows.reduce((acc, row, index) => {
          if (index === 0) return acc;
          const rowCells = Array.from(row.querySelectorAll("td")) || [];
          const rowCell = rowCells.length > 0 ? rowCells[0]?.innerHTML : "";
          const rowCell1 = rowCells.length > 0 ? rowCells[1]?.innerHTML : "";
          const rowCell2= rowCells.length > 0 ? rowCells[2]?.innerHTML : "";
          const rowCell3= rowCells.length > 0 ? rowCells[3]?.innerHTML : "";
          acc.push({
            name: rowCell,
            description: rowCell1,
            image: rowCell2,
            video: rowCell3,
          });
          return acc;
        }, []);
        if (data.length > 0) {
          this.imageTextList = data;
          this.renderImageText();
          this.initTextShowMore();
        } else {
          this.classList.add("hidden");
        }
      }

      extractImageUrlImage(html = "") {
        if (!html || typeof html !== 'string') return "";
        if (!html.includes('<img')) return "";
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const img = doc.querySelector("img[src]");
          return img?.getAttribute("src") || "";
        } catch (error) {
          console.warn('Error parsing HTML for image extraction:', error);
          return "";
        }
      }

      renderImageText() {
        const item = this.imageTextList[this.indexItem];
        if(!item || !this.imageTextItemTemplate) {
          this.classList.add("hidden");
          return;
        }
        const imageTextItem = this.imageTextItemTemplate.content.cloneNode(true);
        const nameEl = imageTextItem.querySelector(".product-image-text-name");
        const descEl = imageTextItem.querySelector(".product-image-text-description");
        if (nameEl) nameEl.innerHTML = item.name || "";
        if (descEl) descEl.innerHTML = item.description || "";
        const defaultImage = "https://wisekingson-straps.com/cdn/shop/files/2.2.jpg";
        let imageUrl = this.extractImageUrlImage(item.image) ? this.extractImageUrlImage(item.image) : defaultImage;
        if(imageUrl) {
          const sourceImage = imageTextItem.querySelector(".product-image-text-image");
          if (sourceImage) {
            const srcTemplate = sourceImage.getAttribute("src") || "";
            const srcsetTemplate = sourceImage.getAttribute("srcset") || "";
            if (srcTemplate) {
              const imageSessionUrl = srcTemplate.replace("{url_image}", imageUrl);
              sourceImage.setAttribute('src', imageSessionUrl);
            }
            if (srcsetTemplate) {
              const imageSessionSizes = srcsetTemplate.replaceAll("{url_image}", imageUrl);
              sourceImage.setAttribute('srcset', imageSessionSizes);
            }
          }
        }
        const urlVideo = item.video ? tripHtml(item.video) : "https://www.youtube.com/embed/85nyox6YIeQ?si=BAF9j81VN1iCgW8d";
        if(urlVideo) {
          const btn = imageTextItem.querySelector(".product-image-text-video__btn");
          if (btn) btn.setAttribute('data-url', urlVideo);
          const videoTemplate = imageTextItem.querySelector("template");
          if (videoTemplate) {
            const iframe = videoTemplate.content.querySelector(".product-image-text-video__iframe");
            if (iframe) iframe.setAttribute('src', urlVideo);
          }
        }
        if (this.imageTextContainer) {
          this.imageTextContainer.appendChild(imageTextItem);
        } else {
          this.classList.add("hidden");
        }
      }
      
      initTextShowMore() {
        if (!this.imageTextContainer) return;
        const blocks = this.imageTextContainer.querySelectorAll('.text_show_more');
        if (!blocks || blocks.length === 0) return;
        blocks.forEach((block, index) => {
          if (block.dataset.initialized === 'true') return;
          const content = block.querySelector('.text_show_more__content');
          const button = block.querySelector('.text_show_more__btn');
          const downIcon = block.querySelector('.svg-wrapper.down');
          const upIcon = block.querySelector('.svg-wrapper.up');
          if (!content || !button) return;
          const collapsedHeight = 200;
          const originalHeight = content.scrollHeight;
          if (originalHeight <= collapsedHeight) {
            button.style.display = 'none';
            block.dataset.initialized = 'true';
            return;
          }
          const unique = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          const contentId = `text-content-${unique}-${index}`;
          const buttonId = `text-button-${unique}-${index}`;
          content.id = contentId;
          button.id = buttonId;
          button.setAttribute('aria-controls', contentId);
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', 'Show more content');
          button.style.display = 'block';
          content.style.height = collapsedHeight + 'px';
          content.style.overflow = 'hidden';
          content.style.transition = 'height 0.3s ease';
          content.classList.add('text_show_more__content--collapsed');
          if (downIcon) downIcon.style.display = 'inline-flex';
          if (upIcon) upIcon.style.display = 'none';
          let isExpanded = false;
          const onClick = () => {
            if (isExpanded) {
              content.style.height = collapsedHeight + 'px';
              content.classList.remove('text_show_more__content--expanded');
              content.classList.add('text_show_more__content--collapsed');
              button.setAttribute('aria-expanded', 'false');
              button.setAttribute('aria-label', 'Show more content');
              if (downIcon) downIcon.style.display = 'inline-flex';
              if (upIcon) upIcon.style.display = 'none';
            } else {
              const targetHeight = content.scrollHeight;
              content.style.height = targetHeight + 'px';
              content.classList.remove('text_show_more__content--collapsed');
              content.classList.add('text_show_more__content--expanded');
              button.setAttribute('aria-expanded', 'true');
              button.setAttribute('aria-label', 'Show less content');
              if (downIcon) downIcon.style.display = 'none';
              if (upIcon) upIcon.style.display = 'inline-flex';
            }
            isExpanded = !isExpanded;
          };
          button.addEventListener('click', onClick);
          button.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              button.click();
            }
          });
          block.dataset.initialized = 'true';
        });
      }
    }
  );
}

